import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=2983e0d4&scoped=true"
import script from "./UserAgreement.vue?vue&type=script&lang=ts"
export * from "./UserAgreement.vue?vue&type=script&lang=ts"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=2983e0d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983e0d4",
  null
  
)

export default component.exports